import { render, staticRenderFns } from "./FCellBtnLink.vue?vue&type=template&id=247111de&scoped=true&"
import script from "./FCellBtnLink.vue?vue&type=script&lang=ts&"
export * from "./FCellBtnLink.vue?vue&type=script&lang=ts&"
import style0 from "./FCellBtnLink.vue?vue&type=style&index=0&id=247111de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247111de",
  null
  
)

export default component.exports